import { render, staticRenderFns } from "./BlogCardMod.vue?vue&type=template&id=e0068bc8"
import script from "./BlogCardMod.vue?vue&type=script&lang=js"
export * from "./BlogCardMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports